
  import { StrictMode } from "react";
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import "./index.css";
  import { installConversionClicks } from './utils/conversionEvents';

  const removeConversionClicks = installConversionClicks();
  if (import.meta.hot) import.meta.hot.dispose(removeConversionClicks);

  function mountApp() {
    document.querySelector('style[data-pf-critical]')?.remove();
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  }

  const pendingStyles = Array.from(
    document.querySelectorAll<HTMLLinkElement>('link[data-pf-deferred-style]')
  ).filter((link) => link.dataset.pfLoaded !== "true" && link.media !== "all");

  if (pendingStyles.length === 0) {
    mountApp();
  } else {
    let mounted = false;
    const tryMount = () => {
      if (mounted) return;
      const ready = pendingStyles.every(
        (link) => link.dataset.pfLoaded === "true" || link.media === "all"
      );
      if (!ready) return;
      mounted = true;
      window.removeEventListener("pf:styles-ready", tryMount);
      mountApp();
    };
    window.addEventListener("pf:styles-ready", tryMount);
    pendingStyles.forEach((link) => {
      link.addEventListener("load", tryMount, { once: true });
      link.addEventListener("error", () => {
        link.dataset.pfLoaded = "true";
        tryMount();
      }, { once: true });
    });
    window.setTimeout(() => {
      pendingStyles.forEach((link) => { link.dataset.pfLoaded = "true"; });
      tryMount();
    }, 4000);
  }

  // The static LCP hero (#static-hero) is removed by App.RouteReady once the
  // lazy page chunk has actually mounted — removing it here (pre-Suspense)
  // would blank the screen while the route chunk is still downloading.
  
